import { render, staticRenderFns } from "./G2CustomSetting.vue?vue&type=template&id=991f72b8&scoped=true"
import script from "./G2CustomSetting.vue?vue&type=script&lang=js"
export * from "./G2CustomSetting.vue?vue&type=script&lang=js"
import style0 from "./G2CustomSetting.vue?vue&type=style&index=0&id=991f72b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991f72b8",
  null
  
)

export default component.exports